/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import config from "../../../config";
import axiosClient from "../../../_helpers/http.helper";
import Select from 'react-select';
import {Button} from "@pearson-components/elements-sdk/build/dist.elements-sdk";
import LoadingIndicator from "../../widgets/LoadingIndicator/LoadingIndicator";
import InfiniteScroll from "react-infinite-scroll-component";
import ReactTable from 'react-table';
import union from "lodash/union";
import {formatUrl} from "../../../_helpers/urlFormat.helper";
import UpdateUserProfile from "./UpdateUserProfile";
import ModalDialog from '../../widgets/ModalDialog/ModalDialog';
import * as EmailValidator from 'email-validator';

export default class AccountsComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            userProfile: [],
            pageSize: 25,
            pageNumber: null,
            totalItems: 0,
            searchValue: "",
            username:"",
            emailId:"",
            failedMsg: "",
            selectedRow: {},
            showLoader: false,
            hasMore: true,
            showResults: false,
            showModal: false,
            sortValue: "asc",
            sortByValue: "username",
            showSecondModal: false,
            secondModalDetail: {
                header: "Error",
                message: "Error"
            },
            default_sort_value: {
                value: "0",
                label: "Ascending(A-Z)"
            },
            default_sortBy_value: {
                value: "0",
                label: "User Name"
            },
            sort_options: [
                {
                    value: "0",
                    label: "Ascending(A-Z)"
                },
                {
                    value: "1",
                    label: "Descending(Z-A)"
                }
            ],
            sortBy_options: [
                {
                    value: "0",
                    label: "User Name"
                },
                {
                    value: "1",
                    label: "First Name"
                },
                {
                    value: "2",
                    label: "Last Name"
                },
                {
                    value: "3",
                    label: "Email"
                }
            ]
        };
        this.searchUsers = this.searchUsers.bind(this);
    }

    changeSortOptions(e) {
        this.setState({
            default_sort_value: {
                value: e.value,
                label: e.label
            }
        });
        this.setSortValue(e.value, () => this.searchUsers(0));
    }

    changeSortByOptions(e) {
        this.setState({
            default_sortBy_value: {
                value: e.value,
                label: e.label
            }
        });
        this.setSortByValue(e.value, () => this.searchUsers(0));
    }

    setSortValue(value, callback){

        if (Number(value) === 0 ){
            this.setState({
                sortValue: "asc"
            }, () => callback());
        }
        else if (Number(value) === 1) {
            this.setState({
                sortValue: "desc"
            }, () => callback());
        }
    }

    setSortByValue(value, callback){

        if (Number(value) === 0 ){
            this.setState({
                sortByValue: "username"
            },() => callback());
        }
        else if (Number(value) === 1) {
            this.setState({
                sortByValue: "firstName"
            },() => callback());
        }
        else if (Number(value) === 2) {
            this.setState({
                sortByValue: "lastName"
            },() => callback());
        }
        else if (Number(value) === 3) {
            this.setState({
                sortByValue: "emailId"
            },() => callback());
        }
    }

    hasMore = () => {
        this.setState({
            hasMore: false
        });
    };

    showSecondModal = (header, message) => {
        this.setState({
            showSecondModal: true,
            secondModalDetail: {
                header: header,
                message: message
            }
        });
    };

    hideModal = () => {
        this.setState({
            showModal: false,
            selectedRow: {}
        });
    };

    hideSecondModal = () => {
        this.setState({
            showModal: false,
            showSecondModal: false
        }, () => {
            this.searchUsers(0);
        });
    };

    getResources = (params) => {
        let searchUrl = formatUrl(
            config.identity.baseUrl,
            config.identity.routes.accounts, params);
        return axiosClient.get(searchUrl);
    };

    validateEmail(){
        let email =  this.state.searchValue.trim();

        if(EmailValidator.validate(email)){
            return true;
        } else{
            this.setState({
                totalItems: 0,
                showResults: false,
                showLoader: false,
                failedMsg:"Please enter a valid email id.",
            });
            return false;
        }
    }

    searchUsers = (pageNumber, ) => {

        if (this.state.searchValue.includes("@")) {
            const isValid = this.validateEmail();
            if (!isValid) {
                return;
            }
        }

        if (pageNumber === 0) {
            this.setState({
                userProfile: [],
                totalItems: 0,
                showLoader: true
            });
        }

        const params = {
            sort: this.state.sortValue,
            sort_by: this.state.sortByValue,
            username: this.state.searchValue.trim(),
            emailId: this.state.searchValue.trim(),
            pageSize: this.state.pageSize,
            pageNumber:
                this.state.userProfile.length == 0
                    ? 0
                    : parseInt(pageNumber),
        };

        this.getResources(params)
            .then(response => {
                const results = response.data;

                this.setState(prevState => ({
                    userProfile: union([
                        ...prevState.userProfile,
                        ...results.content
                    ], 'id'),
                    pageNumber: results.number,
                    totalItems: results.totalElements,
                    hasMore: !results.last,
                    failedMsg: "",
                    showLoader: false,
                    showResults: true
                }));

            }).catch(error => {
                console.log("Error");
                this.setState({
                    showResults: false,
                    showLoader: false,
                    failedMsg: error.response.data.message,
                });
            });
    };

    loadMore = () => {
        if (!this.state.hasMore) {
            return;
        }

        let pageNumber
            = this.state.userProfile.length
            / this.state.pageSize;
        this.searchUsers(pageNumber);
    };

    render() {
        const columns = [
            {
                Header: "Full Name",
                id: 'user',
                sortable: true,
                Cell: row => {
                    return (
                        <div>{row.original.firstName} {row.original.lastName}</div>
                    );
                }
            },
            {
                Header: "User Name",
                accessor: "username",
                sortable: true,
            },
            {
                Header: "Email Address",
                accessor: "email",
                sortable: true
            },
            {
                Header: "User Roles",
                id: 'csgRoles',
                accessor: data => {
                    return data.csgRoles.join(", ");
                }
            },
            {
                Header: "User Geo",
                id: 'geoCode',
                Cell: row => (
                    row.original.geos.map((geo,index) => {
                        return (<div key={index}>{geo.geoCode}</div>);
                    })
                )
            },
            {
                Header: "Scrubbed",
                id: 'scrubbed',
                accessor: data => {
                    return data.geos.map(( geo => geo.scrubbed.toString().charAt(0).toUpperCase() + geo.scrubbed.toString().slice(1))).map((scrubbed,index) => {
                        return (<div key={index}>{scrubbed}</div>);
                    });
                }
            },
            {
                Header: "Unscrubbed",
                id: 'unscrubbed',
                accessor: data => {
                    return data.geos.map(( geo => geo.unscrubbed.toString().charAt(0).toUpperCase() + geo.unscrubbed.toString().slice(1))).map((unscrubbed,index) => {
                        return (<div key={index}>{unscrubbed}</div>);
                    });
                }
            }
        ];

        return (
            <div>
                <div className="accounts-container pe-row">
                    <div className="content-home-page">
                        <div>
                            <label className="pe-page-title--small">Assign Roles to Profile</label>
                            <hr/>
                        </div>
                        <div className="pe-row">
                            <div className="search-param pe-col-4">
                                <label className="param-label">Search:</label>
                                <input type="text" className="param-input pe-textInput--basic"
                                    value={this.state.searchValue}
                                    onChange={e => {
                                        this.setState({searchValue: e.target.value});
                                    }}
                                    placeholder="Enter name or email"
                                    onKeyDown={e => {
                                        if (e.key === "Enter") {
                                            this.searchUsers(0);
                                        }
                                    }}
                                />
                                <div className="search-btn">
                                    <Button type="submit" btnType="primary" onClick={() => this.searchUsers(0)}>Search</Button>
                                </div>
                            </div>
                            <div className="search-param pe-col-4">
                                <label className="param-label2">Sort Order:</label>
                                <div className="order-dropdown">
                                    <Select arrowRenderer={this.props.arrowRenderer || this.arrowDown}
                                        backspaceRemoves={false}
                                        clearable={false}
                                        name={this.state.default_sort_value.label}
                                        value={this.state.default_sort_value.value}
                                        onChange={(e) => this.changeSortOptions(e)}
                                        options={this.state.sort_options}
                                        searchable={false}
                                    />
                                </div>
                            </div>
                            <div className="search-param pe-col-4">
                                <label className="param-label3">Sort By:</label>
                                <div className="sort-dropdown">
                                    <Select arrowRenderer={this.props.arrowRenderer || this.arrowDown}
                                        backspaceRemoves={false}
                                        clearable={false}
                                        name={this.state.default_sortBy_value.label}
                                        value={this.state.default_sortBy_value.value}
                                        onChange={(e) => this.changeSortByOptions(e)}
                                        options={this.state.sortBy_options}
                                        searchable={false}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="error-message">
                            <span>{this.state.failedMsg}</span>
                        </div>
                    </div>
                    {this.state.showLoader ? <LoadingIndicator/> : this.state.userProfile ? this.state.totalItems > 0 ?
                        <div>
                            <div id="scrollTable" className="infiniteScroll">
                                <InfiniteScroll
                                    dataLength={this.state.userProfile.length}
                                    next={this.loadMore}
                                    hasMore={this.state.hasMore}
                                    loader={<LoadingIndicator isDark={false}/>}
                                    scrollableTarget="scrollTable"
                                >
                                    <div className="table-wrap">
                                        <ReactTable
                                            className="-highlight"
                                            data={this.state.userProfile}
                                            showPagination={false}
                                            columns={columns}
                                            defaultPageSize={this.state.totalItems}
                                            minRows={0}
                                            sortable={false}
                                            pageText=""
                                            getTdProps={(state, rowInfo) => {
                                                return {
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    onClick: () => {
                                                        this.setState({
                                                            showModal: true,
                                                            selectedRow: rowInfo.original,
                                                        });
                                                    }
                                                };
                                            }}
                                        />
                                    </div>
                                </InfiniteScroll>
                            </div>
                        </div>: this.state.showResults ? <div className="table-wrap">
                            <ReactTable
                                className="-highlight"
                                showPagination={false}
                                columns={columns}
                                minRows={0}
                                sortable={false}
                                pageText=""
                                noDataText="There's no data to display" />
                        </div> : '' : ''
                    }
                </div>
                {this.state.showModal ? (
                    <UpdateUserProfile
                        showSecondModal={this.showSecondModal}
                        showModal={this.state.showModal}
                        hideModal={this.hideModal}
                        profile={this.state.selectedRow}
                    />
                ) : (" ")}

                {this.state.showSecondModal ? (
                    <ModalDialog
                        title={this.state.secondModalDetail.header}
                        successText={"Ok"}
                        showModal={this.state.showSecondModal}
                        showCancel={false}
                        onSuccess={this.hideSecondModal}
                        onCancel={this.hideSecondModal}
                    >
                        <div>{this.state.secondModalDetail.message}</div>
                    </ModalDialog>
                ) : (
                    ""
                )}

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/Accounts/AccountsComponent.js